import React from 'react';
import classnames from 'classnames';
import './WpCard.scss';
import ColorConstants from '../../colors/ColorConstants';

export interface Props {
  children?: React.ReactNode;
  className?: string;
  centered?: boolean;
  accent?: ColorConstants;
}

const WpCard: React.FC<Props> = ({ children, className, centered = false, accent }: Props) => {
  const classNamePrefix = 'WpCard';
  const classes = classnames(classNamePrefix, className, centered ? `${classNamePrefix}--centered` : false);

  return (
    <div className={classes}>
      {accent && <div className={`${classNamePrefix}__accent`} style={{ backgroundColor: accent }} />}
      {children}
    </div>
  );
};

export default WpCard;
